/**
 * The sign-in page's cookie writes, for the AngularJS login page and the
 * access island alike: each host supplies the cookie writer (angular-cookies,
 * or `document.cookie`), core-account decides the names and lifetimes.
 */

import { LOGIN_COOKIES, SESSION_HANDOFF_DELAY_MS, loginCookieExpiry } from '@dealr/core-account';

/** Writes one cookie on the page's host, path `/`, secure over https. */
export interface LoginCookieWriter {
  put(name: string, value: string, expires: Date): void;
}

/** The username the sign-in form opens with next time. */
export function rememberLoginUsername(cookies: LoginCookieWriter, username: string, now: number): void {
  cookies.put(LOGIN_COOKIES.username, username, loginCookieExpiry('username', now));
}

/** The signed-in session the dealer and admin apps read (`auth`). */
export function writeSessionCookie(cookies: LoginCookieWriter, session: object, now: number): void {
  cookies.put(LOGIN_COOKIES.session, JSON.stringify(session), loginCookieExpiry('session', now));
}

export interface SessionHandoffDeps {
  cookies: LoginCookieWriter;
  now(): number;
  later(fn: () => void, ms: number): void;
}

/**
 * main.js `completeLogin`: the session cookie, the device token for a year,
 * then after SESSION_HANDOFF_DELAY_MS `then` (the host announces the sign-in to
 * its other tabs and navigates).
 */
export function handOffSession(deps: SessionHandoffDeps, session: object, deviceToken: string, then: () => void): void {
  const now = deps.now();
  writeSessionCookie(deps.cookies, session, now);
  deps.cookies.put(LOGIN_COOKIES.deviceToken, deviceToken, loginCookieExpiry('deviceToken', now));
  deps.later(then, SESSION_HANDOFF_DELAY_MS);
}
